import type { TMessages } from '@/types/TMessages'

export const messages = {
  noAccountsErrorModal: {
    mainMessage: 'Пожалуйста, обратитесь в техническую поддержку',
    phone: 'Тел.',
    email: 'Email',
  },
} satisfies TMessages
